import { jsx as _jsx } from "react/jsx-runtime";
import { twMerge } from 'tailwind-merge';
const SkeletonText = ({ className }) => (_jsx("div", { className: twMerge('h-4 w-full bg-neutral-100 rounded-md', className) }));
const SkeletonButton = ({ className }) => (_jsx("div", { className: twMerge('mr-12 h-10 w-[86px] bg-neutral-100 rounded-md', className) }));
const skeletonTypes = {
    Text: SkeletonText,
    Button: SkeletonButton,
};
export const Skeleton = ({ component, className = '', innerClassName = '' }) => (_jsx("div", { className: twMerge('animate-pulse', className), children: skeletonTypes[component]({ className: innerClassName }) }));
